import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import { Box, Flex, Text } from "rebass";
import { toastr } from "react-redux-toastr";
import { object, string } from "yup";
import get from "lodash/get";

import { getUser } from "../../../store/modules/session/selectors";

import { FormComponent } from "./FormComponent";
import {
  FormActionTypes,
  initialValues,
  validationSchema,
  ValueTypes,
} from "./formSettings";

import { makeReportIssue, TValues } from "../../../utils/makeReportIssue";

interface IProps {
  successCallback(): void;
}

export const ReportIssueForm: React.FC<IProps> = ({ successCallback }) => {
  const user = useSelector(getUser);
  const handleOnSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    try {
      const { uid } = object({ uid: string().required("User is undefined") }).validateSync(user);

      makeReportIssue({ ...values, uid } as TValues)
        .then(({ issueId }) => {
          console.log(`issue ID ${issueId}`);
          successCallback();
        })
        .catch(({ message }) => {
          toastr.error("Report an Issue", message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } catch ({ message }) {
      toastr.error("Report an Issue", message);
      actions.setSubmitting(false);
    }
  }, [user, successCallback]);

  const email = get(user, "email") || initialValues.email;

  return (
    <Flex
      height="100%"
      flexDirection="column"
      p="65px 100px 35px"
    >
      <Text
        as="h3"
        color="#2b3160"
        fontSize="30px"
        fontWeight="bold"
        lineHeight="1.07"
      >
        Report an Issue
      </Text>

      <Box
        mt="40px"
        flex="1"
        css="overflow: hidden;"
      >
        <Formik
          initialValues={{ ...initialValues, email }}
          validationSchema={validationSchema}
          onSubmit={handleOnSubmit}
          component={FormComponent}
          enableReinitialize
        />
      </Box>
    </Flex>
  );
};
